<!-- 课程实操 -->
<template>
    <div>
      <div class="course_PracticalTraining">
        <el-row class="mb10">
          <label>班级：</label>
          <el-select clearable v-model="classId" placeholder="请选择班级">
            <template v-for="(item ,index) in classList">
              <el-option :label="item.schoolClassIdText" :value="item.schoolClassId"></el-option>
            </template>
          </el-select>
          <el-button type="primary" icon="el-icon-search" @click="getInfo(page = 1)">搜索</el-button>
          <el-button type="success" icon="el-icon-plus" @click="addPractical">新增</el-button>
          <el-button type="success" icon="el-icon-printer" @click="exportInfo">导出</el-button>
          <el-button type="warning" icon="el-icon-download" :disabled="reportPacking" @click="exportAllReports">导出全部报告</el-button>
        </el-row>
        <el-row class="mb10 re_bar" v-if="reportPacking">
          <el-progress :percentage="reportPercent" :stroke-width="8" :show-text="false"></el-progress>
          <p class="re_tip">{{reportTip}}</p>
        </el-row>
        <el-row class="mb10">
          <label>章节练习汇总：</label>
          【
            观看视频平均得分：<span style="color: #409EFF;margin-right: 20px;">{{Number(listCount.videoAvgScore || 0).toFixed(2)}}</span>
            观看PPT平均得分：<span style="color: #409EFF;margin-right: 20px;">{{Number(listCount.pptAvgScore || 0).toFixed(2)}}</span>
            理论测评平均得分：<span style="color: #409EFF;margin-right: 20px;">{{Number(listCount.theoryAvgScore || 0).toFixed(2)}}</span>
            实训操作步骤平均得分：<span style="color: #409EFF;margin-right: 20px;">{{Number(listCount.stepAvgScore || 0).toFixed(2)}}</span>
            报告撰写平均得分：<span style="color: #409EFF;">{{Number(listCount.reportAvgScore || 0).toFixed(2)}}</span>
          】
        </el-row>
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column type="index" header-align="center" align="center" width="80" label="序号"></el-table-column>
          <el-table-column prop="handsOnName" header-align="center" align="center" label="项目名称"> </el-table-column>
          <el-table-column prop="videoAvgScore" header-align="center" align="center" label="观看视频平均得分">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="lookMp4(scope.row)">{{scope.row.videoAvgScore}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="pptAvgScore" header-align="center" align="center" label="观看PPT平均得分">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="lookPpt(scope.row)">{{scope.row.pptAvgScore}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="theoryAvgScore" header-align="center" align="center" label="理论测评平均得分">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="lookTheory(scope.row)">{{scope.row.theoryAvgScore}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="stepAvgScore" header-align="center" align="center" label="实训操作步骤平均得分">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="lookPractical(scope.row)">{{scope.row.stepAvgScore}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="reportAvgScore" header-align="center" align="center" label="报告撰写平均得分">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" @click="lookReport(scope.row)">{{scope.row.reportAvgScore}}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="user_" header-align="center" align="center" label="操作" width="480">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" class="mr10" @click="practicalResults(scope.row)">实操成绩</el-link>
              <el-link type="primary" :underline="false" class="mr10" @click="practicalReview(scope.row)">评阅</el-link>
              <el-link type="primary" :underline="false" class="mr10" @click="editInfo(scope.row)">编辑</el-link>
              <el-link type="primary" :underline="false" class="mr10" @click="delInfo(scope.row)">删除</el-link>
              <el-link type="primary" :underline="false" class="mr10" @click="knowledgePoints(scope.row)">绑定知识点</el-link>
              <el-link type="primary" :underline="false" class="mr10" @click="seePractice(scope.row)">查看内容</el-link>
              <el-link type="primary" :underline="false" @click="exportProjectReports(scope.row)">
                <i class="el-icon-loading" v-if="reportPacking && String(reportExportingId) === String(scope.row.handsOnId)"></i>
                {{reportPacking && String(reportExportingId) === String(scope.row.handsOnId) ? '导出中' : '导出报告'}}
              </el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[8, 20, 50, 100]"
            :page-size="limit"
            background
            :hide-on-single-page="true"
            layout="sizes, prev, pager, next,jumper"
            :total="total">
          </el-pagination>
        </div>

        <!-- 绑定知识点 -->
        <el-dialog
          title="绑定知识点"
          :visible.sync="knowledgePointsShow"
          width="800px"
        >
          <span slot="title">
            <i class="el-icon-notebook-2" style="margin-right: 10px;color: #67C23A;"></i>绑定知识点
          </span>
          <label>归属课程：</label>
          <el-select disabled @change="getCourseInfoList" v-model="pointsInfo.teacherOpenCourseId" placeholder="请选择课程">
            <template v-for="(item ,index) in courseList">
              <el-option :label="item.teacherOpenCourseIdText || item.teacherOpenCourseTitle" :value="item.teacherOpenCourseId"></el-option>
            </template>
          </el-select>
          <label class="ml20">归属章节：</label>
          <el-select clearable  @change="getPageList" v-model="pointsInfo.chapterId" placeholder="请选择章节">
            <template v-for="(item ,index) in courseInfoList">
              <el-option :label="item.courseInfoName" :value="item.teacherOpenCourseMergeCourseInfoId"></el-option>
            </template>
          </el-select>
          <el-row class="mt20 mb20">
            <el-transfer v-model="value" :props="{key: 'teacherOpenCourseKnowledgePointId',label: 'knowledgePointTitle'}":titles="['未绑定知识点', '已绑定知识点']" :data="data"></el-transfer>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="knowledgePointsShow = false">取 消</el-button>
            <el-button type="primary" @click="submitPoints">确 认</el-button>
          </span>
        </el-dialog>

      </div>
    </div>
</template>
<script>
import {getClassInfo,getCourseList,getCourseInfoList} from "@/common/getInfo";	//加载数据
// ===== ZIP_PACK_BEGIN =====
// 纯前端 ZIP 打包（store 模式，不压缩）。报告文件本身已是 PDF/Word 等压缩格式，
// 再做 deflate 收益极小，store 模式实现简单、不会被老浏览器卡住，产物可被 Windows/7-Zip 正常打开。
const CRC32_TABLE = (function () {
  let table = new Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
    table[n] = c >>> 0;
  }
  return table;
})();

function crc32(bytes) {
  let c = -1;
  for (let i = 0; i < bytes.length; i++) c = (c >>> 8) ^ CRC32_TABLE[(c ^ bytes[i]) & 0xFF];
  return (c ^ -1) >>> 0;
}

// 中文文件名必须转成 UTF-8 字节，并把通用标志位置 0x0800，否则 Windows 解压全是乱码
function zipUtf8Bytes(str) {
  if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(str);
  let encoded = unescape(encodeURIComponent(str));
  let out = new Uint8Array(encoded.length);
  for (let i = 0; i < encoded.length; i++) out[i] = encoded.charCodeAt(i);
  return out;
}

// entries: [{ name: '目录/文件.pdf', data: Uint8Array }]
function buildZipBlob(entries) {
  let now = new Date();
  let dosTime = ((now.getHours() << 11) | (now.getMinutes() << 5) | (now.getSeconds() >> 1)) & 0xFFFF;
  let dosDate = (((now.getFullYear() - 1980) << 9) | ((now.getMonth() + 1) << 5) | now.getDate()) & 0xFFFF;

  let parts = [];
  let central = [];
  let offset = 0;

  entries.forEach(function (entry) {
    let nameBytes = zipUtf8Bytes(entry.name);
    let data = entry.data;
    let size = data.length;
    let crc = crc32(data);

    let local = new Uint8Array(30 + nameBytes.length);
    let lv = new DataView(local.buffer);
    lv.setUint32(0, 0x04034b50, true); // 本地文件头签名
    lv.setUint16(4, 20, true); // 解压所需版本
    lv.setUint16(6, 0x0800, true); // 标志位：文件名 UTF-8
    lv.setUint16(8, 0, true); // 压缩方式 0 = store
    lv.setUint16(10, dosTime, true);
    lv.setUint16(12, dosDate, true);
    lv.setUint32(14, crc, true);
    lv.setUint32(18, size, true); // 压缩后大小
    lv.setUint32(22, size, true); // 原始大小
    lv.setUint16(26, nameBytes.length, true);
    lv.setUint16(28, 0, true); // 扩展字段长度
    local.set(nameBytes, 30);

    parts.push(local, data);

    let cd = new Uint8Array(46 + nameBytes.length);
    let cv = new DataView(cd.buffer);
    cv.setUint32(0, 0x02014b50, true); // 中央目录签名
    cv.setUint16(4, 20, true); // 创建版本
    cv.setUint16(6, 20, true); // 解压所需版本
    cv.setUint16(8, 0x0800, true);
    cv.setUint16(10, 0, true);
    cv.setUint16(12, dosTime, true);
    cv.setUint16(14, dosDate, true);
    cv.setUint32(16, crc, true);
    cv.setUint32(20, size, true);
    cv.setUint32(24, size, true);
    cv.setUint16(28, nameBytes.length, true);
    cv.setUint16(30, 0, true); // 扩展字段
    cv.setUint16(32, 0, true); // 注释
    cv.setUint16(34, 0, true); // 起始磁盘号
    cv.setUint16(36, 0, true); // 内部属性
    cv.setUint32(38, 0, true); // 外部属性
    cv.setUint32(42, offset, true); // 本地头偏移
    cd.set(nameBytes, 46);

    central.push(cd);
    offset += local.length + size;
  });

  let cdSize = 0;
  central.forEach(function (c) { cdSize += c.length; });

  let eocd = new Uint8Array(22);
  let ev = new DataView(eocd.buffer);
  ev.setUint32(0, 0x06054b50, true); // 中央目录结束签名
  ev.setUint16(4, 0, true);
  ev.setUint16(6, 0, true);
  ev.setUint16(8, entries.length, true);
  ev.setUint16(10, entries.length, true);
  ev.setUint32(12, cdSize, true);
  ev.setUint32(16, offset, true);
  ev.setUint16(20, 0, true);

  return new Blob(parts.concat(central, [eocd]), { type: "application/zip" });
}
// ===== ZIP_PACK_END =====

export default {
  name: 'Practice',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  data() {
    return {
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      knowledgePointsShow:false,
      pointsInfo:{
        teacherOpenCourseId:"",
        chapterId:""
      },
      classId:"",
      data: [],
      value: [],
      classList:[],
      listCount:{},
      courseList:[],
      courseInfoList:[],
      // ==================== 导出实训报告 ====================
      reportPacking: false, //正在打包
      reportExportingId: "", //正在导出的实训项目ID（用于行内按钮显示进度）
      reportPercent: 0, //打包进度
      reportTip: "" //打包进度文案
    }
  },
  created() {
    this.getInfo();
    this.getOnListCount();
    getClassInfo({teacherOpenCourseId:this.courseId}).then(ret =>{ //根据课程ID获取班级信息
      if(ret.code == 0){
        this.classList = ret.data;
      }
    });
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getCourseList(){ //获取课程
      if(this.courseList.length <= 0){
        getCourseList().then((ret) =>{
          if(ret.code == 0){
            this.courseList = ret.data;
            this.pointsInfo.teacherOpenCourseId = this.courseId;
            this.getCourseInfoList();
          }
        });
      }else{
        this.pointsInfo.teacherOpenCourseId = this.courseId;
        this.getCourseInfoList();
      }
    },
    getCourseInfoList(){ //获取章节
      getCourseInfoList({teacherOpenCourseId:this.pointsInfo.teacherOpenCourseId,chapterId:this.pointsInfo.chapterId}).then((ret) =>{
        if(ret.code == 0){
          this.courseInfoList = ret.data;
          this.getPageList();
        }
      });
    },
    getInfo(){
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId
      }
      this.$get("/jlw/teacherOpenCourseHandsOn/getHandsOnList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getOnListCount(){ //获取课程实操汇总
      let param = {
        teacherOpenCourseId:this.courseId,
        classId:this.classId
      }
      this.$get("/jlw/teacherOpenCourseHandsOn/getHandsOnListCount.do",param).then((ret) =>{
        if(ret.code == 0){
          this.listCount = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    lookMp4(item){ //查看视频得分详情
      this.$router.push({name:'Mp4Details',query:{courseId:this.courseId,id:item.handsOnId}});
    },
    lookPpt(item){ //查看PPT得分详情
      this.$router.push({name:'PPTDetails',query:{courseId:this.courseId,id:item.handsOnId}});
    },
    lookTheory(item){ //查看理论得分详情
      this.$router.push({name:'TheoryDetails',query:{courseId:this.courseId,id:item.handsOnId}});
    },
    lookPractical(item){ //查看实训得分详情
      this.$router.push({name:'PracticalDetails',query:{courseId:this.courseId,id:item.handsOnId}});
    },
    lookReport(item){ //查看报告撰写得分详情
      this.$router.push({name:'ReportDetails',query:{courseId:this.courseId,id:item.handsOnId}});
    },
    practicalResults(item){ //实操成绩
      this.$router.push({name:'PracticalResults',query:{courseId:this.courseId,id:item.handsOnId}});
    },
    practicalReview(item){ //评阅
      this.$router.push({name:'PracticalReview',query:{courseId:this.courseId,id:item.handsOnId}});
    },
    questionList(item){ //试题管理
      this.$router.push({name:'QuestionList',query:{courseId:this.courseId,id:item.handsOnId}});
    },
    lookQuestions(item){ //查看试题
      this.$router.push({name:'TExercises',query:{type:3,item:item}});
    },
    addPractical(){ //新增实训
      this.$router.push({name:'AddPractical',query:{courseId:this.courseId}});
    },
    exportInfo(){ //导出信息
      this.$confirm('是否确定导出信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$downLoadFile('/jlw/teacherOpenCourseHandsOn/exportHandsOnList.do?teacherOpenCourseId='+this.courseId, `课程实操信息-导出${new Date().toLocaleString()}.xlsx`);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    editInfo(item){
      this.$router.push({name:'AddPractical',query:{courseId:this.courseId,handsOnId:item.handsOnId}});
    },
    delInfo(item){
      this.$confirm('是否确定删除信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("/jlw/teacherOpenCourseHandsOn/delete.do",{ids:item.handsOnId}).then((ret) =>{
          if(ret.code == 0){
            this.getInfo();
            this.$message({type: 'success',message: '删除成功！'});
          }else{
            this.$message({message: ret.msg,type: 'error'});
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    seePractice(item){ //查看实操内容
      this.$router.push({name:'SeePractice',query:{courseId:this.courseId,id:item.handsOnId}});
    },
    knowledgePoints(item){ //绑定知识点
      this.knowledgePointsShow = true;
      this.getCourseList();
      this.pointsInfo.bussinessId = item.handsOnId; //业务ID
      this.pointsInfo.chapterId = null;
      this.value = item.bindingKnowledgeIds || [];
      this.getSelectedIds({handsOnId:this.pointsInfo.bussinessId}); //重新获取已选择的知识点IDS
    },
    getPageList(){ //根据课程ID获取知识点
      let param = {
        teacherOpenCourseId:this.pointsInfo.teacherOpenCourseId,
        chapterId:this.pointsInfo.chapterId
      }
      this.$post("/api/teacherOpenCourseKnowledgePoint/getKnowledgePoint.do",param).then((ret) =>{
        if(ret.code == 0){
          this.data = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    submitPoints(){ //提交知识点绑定
      // if(this.value.length <= 0){
      //   this.$message({message: '请选择需要绑定的知识点！',type: 'warning'});
      //   return;
      // }
      this.pointsInfo.teacherOpenCourseKnowledgePointIdPlural = this.value.join(",");
      this.pointsInfo.bussinessType = 2;//业务类型1章节练习2课程实操
      let param = this.pointsInfo;
      param.teacherOpenCourseId = "";
      param.chapterId = "";
      param.teacherOpenCourseId = this.courseId;
      this.$post("/jlw/teacherOpenCourseKnowledgePointRelation/add.do",param).then((ret) =>{
        if(ret.code == 0){
          this.knowledgePointsShow = false;
          this.$message({type: 'success',message: '绑定成功！'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getSelectedIds(item){ //获取已绑定知识点
      this.$get("/api/teacherOpenCourseKnowledgePointRelation/getBoundKnowledgeList.do",{teacherOpenCourseId:this.courseId,bussinessId:item.handsOnId,bussinessType:2}).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){
            this.value = ret.data;
          }else{
            this.value = [];
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });

    },
    // ==================== 导出实训报告 ====================
    exportProjectReports(row) { //点击某个实训，直接导出该实训下全部学生的报告
      if (this.reportPacking) {
        this.$message.warning("正在导出报告，请等待本次导出完成");
        return;
      }
      if (!row || !row.handsOnId) {
        this.$message.error("缺少实训项目信息");
        return;
      }
      const projectName = row.handsOnName || "实训报告";
      this.reportPacking = true;
      this.reportExportingId = row.handsOnId;
      this.reportPercent = 0;
      this.reportTip = "正在读取《" + projectName + "》的学生报告…";
      this.$post("/api/studentHandsOnTaskReport/getPageList.do", {
        limit: 9999,
        page: 1,
        teacherOpenCourseId: this.courseId,
        handsOnId: row.handsOnId
      }).then((ret) => {
        if (!ret || ret.code != 0) {
          this.finishReportExport();
          this.$message.error((ret && ret.msg) || "获取报告记录失败");
          return;
        }
        let tasks = [];
        let used = {};
        (ret.data || []).forEach((item) => {
          this.parseReportFiles(item.reportFile).forEach((f) => {
            tasks.push({ path: this.buildReportPath(item, f, used), url: f.fileUrl });
          });
        });
        if (tasks.length === 0) {
          this.finishReportExport();
          this.$message.warning("《" + projectName + "》还没有学生提交报告");
          return;
        }
        this.downloadReportEntries(tasks, projectName);
      }).catch(() => {
        this.finishReportExport();
        this.$message.error("获取报告记录失败，请稍后重试");
      });
    },
    exportAllReports() { //导出本课程全部实训项目的所有学生报告（整课程维度）
      if (this.reportPacking) {
        this.$message.warning("正在导出报告，请等待本次导出完成");
        return;
      }
      this.$confirm("将导出本课程全部学生的实训报告，数量较多时耗时较长，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.reportPacking = true;
        this.reportExportingId = "";
        this.reportPercent = 0;
        this.reportTip = "正在读取本课程全部学生的实训报告…";
        this.$post("/api/studentHandsOnTaskReport/getPageList.do", { // 后端待实现：支持不带 handsOnId、仅按 teacherOpenCourseId 查询全部实训报告
          limit: 9999,
          page: 1,
          teacherOpenCourseId: this.courseId
        }).then((ret) => {
          if (!ret || ret.code != 0) {
            this.finishReportExport();
            this.$message.error((ret && ret.msg) || "获取报告记录失败");
            return;
          }
          let tasks = [];
          let used = {};
          (ret.data || []).forEach((item) => {
            this.parseReportFiles(item.reportFile).forEach((f) => {
              tasks.push({ path: this.buildReportPath(item, f, used, true), url: f.fileUrl });
            });
          });
          if (tasks.length === 0) {
            this.finishReportExport();
            this.$message.warning("本课程还没有学生提交实训报告");
            return;
          }
          this.downloadReportEntries(tasks, "全部实训报告");
        }).catch(() => {
          this.finishReportExport();
          this.$message.error("获取报告记录失败，请稍后重试");
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    downloadReportEntries(tasks, projectName) { //逐份下载后在前端打包成 zip
      let entries = [];
      let failed = [];
      let i = 0;
      const next = () => {
        if (i >= tasks.length) {
          this.finishReportExport();
          if (entries.length === 0) {
            this.$message.error("全部 " + tasks.length + " 份报告下载失败，无法打包");
            return;
          }
          try {
            let blob = buildZipBlob(entries);
            this.saveBlob(blob, this.safeFileName(projectName) + "-实训报告-" + this.stamp() + ".zip");
            this.$message.success("已导出《" + projectName + "》" + entries.length + " 份报告" + (failed.length ? "，" + failed.length + " 份下载失败" : ""));
          } catch (e) {
            this.$message.error("打包失败：" + (e && e.message ? e.message : e));
          }
          return;
        }
        let task = tasks[i];
        i++;
        this.reportPercent = Math.round((i - 1) / tasks.length * 100);
        this.reportTip = "正在下载 " + i + "/" + tasks.length + "：" + task.path;
        this.fetchFileBytes(task.url).then((bytes) => {
          entries.push({ name: task.path, data: bytes });
        }).catch(() => {
          failed.push(task.path);
        }).then(() => {
          this.reportPercent = Math.round(i / tasks.length * 100);
          setTimeout(next, 0);
        });
      };
      next();
    },
    finishReportExport() { //收尾：清掉进度状态
      this.reportPacking = false;
      this.reportExportingId = "";
      this.reportPercent = 0;
      this.reportTip = "";
    },
    parseReportFiles(reportFile) { //报告文件字段是 JSON 字符串数组，含 fileName / fileUrl
      if (!reportFile) return [];
      let arr = reportFile;
      if (typeof reportFile === "string") {
        try {
          arr = JSON.parse(reportFile);
        } catch (e) {
          return [];
        }
      }
      if (!Array.isArray(arr)) return [];
      return arr.filter(f => f && f.fileUrl).map(f => ({
        fileName: f.fileName || this.pickNameFromUrl(f.fileUrl),
        fileUrl: f.fileUrl
      }));
    },
    pickNameFromUrl(url) { //从地址里兜底取文件名
      let s = String(url || "");
      let i = s.lastIndexOf("/");
      return i > -1 ? s.substring(i + 1) : (s || "报告文件");
    },
    safeFileName(name) { //去掉文件名里的非法字符
      return String(name || "").replace(/[\\/:*?"<>|]/g, "_").trim();
    },
    buildReportPath(row, file, used, includeProject) { //zip 内的相对路径：整课程导出为 项目名/学号_姓名/文件名，单实训导出为 学号_姓名/文件名
      let parts = [];
      if (includeProject) {
        parts.push(this.safeFileName(row.handsOnName) || "实训项目");
      }
      let student = this.safeFileName([row.studentSn, row.studentName].filter(Boolean).join("_")) || "学生";
      parts.push(student);
      let fname = this.safeFileName(file.fileName) || "报告文件";
      let path = parts.join("/") + "/" + fname;
      let n = 1;
      while (used[path]) { //同一学生同名文件加序号，避免互相覆盖
        let dot = fname.lastIndexOf(".");
        let base = dot > -1 ? fname.substring(0, dot) : fname;
        let ext = dot > -1 ? fname.substring(dot) : "";
        path = parts.join("/") + "/" + base + "(" + (++n) + ")" + ext;
      }
      used[path] = 1;
      return path;
    },
    fetchFileBytes(url) { //按现有下载约定取文件二进制：完整地址直连，/api、/jlw 走业务网关
      return new Promise((resolve, reject) => {
        if (!url) {
          reject(new Error("文件地址为空"));
          return;
        }
        let full = url;
        if (/^https?:\/\//i.test(url)) {
          full = url;
        } else if (/^\/(api|jlw)\//i.test(url)) {
          full = window.configs.API_ROOT + url;
        } else {
          full = this.$isHttp(url);
        }
        let xhr = new XMLHttpRequest();
        xhr.open("GET", full, true);
        xhr.responseType = "arraybuffer";
        xhr.timeout = 120000;
        let token = this.$getToken();
        if (token) xhr.setRequestHeader("token", token);
        xhr.onload = () => {
          if (xhr.status === 200 && xhr.response) {
            resolve(new Uint8Array(xhr.response));
          } else {
            reject(new Error("HTTP " + xhr.status));
          }
        };
        xhr.onerror = () => reject(new Error("网络错误"));
        xhr.ontimeout = () => reject(new Error("超时"));
        xhr.send();
      });
    },
    saveBlob(blob, filename) { //保存 blob 到本地
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
        return;
      }
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    },
    stamp() { //文件名用的时间戳
      let d = new Date();
      const pad = (n) => (n < 10 ? "0" + n : "" + n);
      return d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + "-" + pad(d.getHours()) + pad(d.getMinutes());
    },
  }
};
</script>
<style  lang="less">
  .course_PracticalTraining{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .title_practice{
      margin: 0;
      margin-left: 15px;float: left;
      width: calc(100% - 155px);
    }
    .number_practice{
      margin: 0;
      float: right;
      width: 140px;
      text-align: right;
    }
    .grade_Practice{
      display: flex;
      justify-content:center;
      align-items:center;
      width: 80px;height: 80px;margin: 0 auto;
      font-size: 22px;
      color: #F83131;
      background-color: #FFF6F6;
      border-radius: 50%;
      span{
        font-size: 14px;
        margin-left: 2px;
      }
    }
    .practice_img{
      width: 30px;
      height: 30px;
    }
    .el-transfer-panel{
      width: 280px !important;
    }
    @media screen and (max-width:1536px){
      li{
        width: calc(33% - 66px);
      }
    }
  }

  /* ==================== 导出实训报告（行内导出） ==================== */
  .re_bar{
    padding: 10px 14px;
    background-color: #F5F7FA;
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    .re_tip{
      margin: 8px 0 0 0;
      font-size: 12px;
      color: #909399;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/PracticalTraining/PracticalTraining.vue